import { useCallback, useEffect } from 'react';

import { usePlaidLink } from 'react-plaid-link';
import { useMutation } from '@apollo/client';

import { useAuth } from '../../../context/Auth';

import { SET_PLAID_ACCESS_TOKEN } from '../../../http/apollo-queries';
import { logger } from '../../../helpers/logger';

export const BankConnect = ({
  token,
  onCompleted,
  onExit,
}: {
  token: string;
  onCompleted(d: any): void;
  onExit(): void;
}) => {
  const { user } = useAuth();
  const { profile } = user!;
  const { id: profileId } = profile!;

  const [setAccessToken] = useMutation(SET_PLAID_ACCESS_TOKEN, {
    onCompleted, // setAssetCategorySelection with the new bank
    onError(error) {
      onExit();
      logger.error(error);
    },
  });

  const onSuccess = useCallback(
    (publicToken: string) => {
      setAccessToken({ variables: { profileId, publicToken } });
    },
    [profileId, setAccessToken]
  );

  const config: Parameters<typeof usePlaidLink>[0] = {
    token,
    onSuccess,
    onExit,
  };

  const { open, ready } = usePlaidLink(config);

  useEffect(() => {
    ready && open();
  }, [ready, open]);

  return <></>;
};
